import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { sections } from '../data/sections';
import { SectionPage } from '../components/sections/SectionPage';
export function SectionView() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const sectionIndex = sections.findIndex(s => s.id === id);
  const section = sectionIndex >= 0 ? sections[sectionIndex] : null;
  // Scroll to top whenever the section changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [id]);
  if (!section) {
    return <Navigate to="/" replace data-id="element-332" />;
  }
  const prevSection = sectionIndex > 0 ? sections[sectionIndex - 1] : null;
  const nextSection = sectionIndex < sections.length - 1 ? sections[sectionIndex + 1] : null;
  return <SectionPage section={section} prevSection={prevSection} nextSection={nextSection} data-id="element-333" />;
}